import { COACHES } from "@/data/content";
import { Reveal, SectionHead } from "@/components/site/Reveal";

const Portrait = ({ initials, photo, name, pos }) => photo ? (
  <div className="relative h-full min-h-[300px] overflow-hidden bg-[#0f1420]">
    <img src={photo} alt={name} data-testid="coach-photo" loading="lazy" style={{ objectPosition: pos || "50% 0%" }} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
  </div>
) : (
  <div className="relative h-full min-h-[300px] bg-gradient-to-br from-[#16203a] to-[#0f1420] overflow-hidden flex items-center justify-center">
    <span className="font-display font-extrabold tracking-tighter text-[6rem] leading-none text-white/[0.12] select-none">{initials}</span>
    <p className="absolute bottom-4 left-4 text-[11px] font-mono-epl uppercase tracking-wider text-slate-500">Portrait coming soon</p>
  </div>
);

const CoachCard = ({ c, i }) => (
  <Reveal delay={i * 0.1} className="grid sm:grid-cols-5 gap-0 rounded-3xl overflow-hidden border border-white/10 bg-white/[0.03] group hover:border-[var(--accent)]/40 transition-colors">
    <div className="sm:col-span-2"><Portrait initials={c.initials} photo={c.photo} name={c.name} pos={c.photoPos} /></div>
    <div className="sm:col-span-3 p-7 md:p-9 flex flex-col" data-testid={`coach-card-${i}`}>
      <p className="eyebrow self-start">{c.role}</p>
      <h3 className="mt-3 font-display text-2xl md:text-3xl font-extrabold tracking-tight leading-tight">{c.name}</h3>
      <p className="mt-4 inline-flex self-start rounded-full bg-[var(--accent)]/10 border border-[var(--accent)]/25 px-3 py-1 text-xs font-mono-epl accent-text">{c.licence}</p>
      <ul className="mt-6 space-y-3">
        {c.points.map((p) => (
          <li key={p} className="flex gap-3 text-sm text-slate-300 leading-relaxed">
            <span className="mt-[9px] w-1.5 h-1.5 rounded-full bg-[var(--accent)] shrink-0" />{p}
          </li>
        ))}
      </ul>
    </div>
  </Reveal>
);

export const Coaches = () => (
  <section id="coaches" data-testid="coaches-section" className="section">
    <SectionHead
      eyebrow="Coaching Staff"
      testid="coaches-title"
      title={<>Coached by people<br />who have <span className="accent-text">done it</span></>}
      intro="Our coaches hold UEFA A licences — one of the highest coaching qualifications in European football."
    />
    <div className="grid xl:grid-cols-2 gap-6">
      {COACHES.map((c, i) => <CoachCard key={c.name} c={c} i={i} />)}
    </div>
    <div className="mt-6 grid sm:grid-cols-2 gap-6">
      {[1, 2].map((n) => (
        <div key={n} data-testid={`assistant-coach-${n}`} className="rounded-3xl border border-dashed border-white/15 p-7 flex items-center justify-between">
          <div>
            <p className="text-[11px] font-mono-epl uppercase tracking-wider text-slate-500">Assistant Coach</p>
            <p className="mt-2 font-display text-xl font-bold text-slate-300">To be announced</p>
          </div>
          <span className="font-mono-epl text-sm text-slate-600">0{n + 2}</span>
        </div>
      ))}
    </div>
  </section>
);
